import type { SVGProps } from "react";

/** Track Application sidebar nav icon (Figma). Uses `currentColor` for theme-driven fill. */
export const TrackApplicationNavIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		aria-hidden
		{...props}
	>
		<path
			d="M5.5 2.5H14.5C15.6046 2.5 16.5 3.39543 16.5 4.5V15.5C16.5 16.6046 15.6046 17.5 14.5 17.5H5.5C4.39543 17.5 3.5 16.6046 3.5 15.5V4.5C3.5 3.39543 4.39543 2.5 5.5 2.5Z"
			stroke="currentColor"
			strokeWidth="1.25"
		/>
		<path
			d="M5.75 10.25H7.5L8.75 7.75L10.75 12.75L12.25 9.75H14.25"
			stroke="currentColor"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
